angular.module('wbDashboard').controller('OverviewSummaryTodayControllerAurea',
    ['$scope', 'User', 'Guidance',
function ($scope, User, Guidance) {

    $scope.GD = Guidance;

    $scope.recommendationLimit = 50;

    $scope.reloadGuidance = function() {
        Guidance.resetView();
    };

    // unnecessary to getRecommendations since it calls in the recommendation controller to handle that
    // $scope.$watch(function() { return PlanningService.getRecommendations(); }, function(recommendations) {
    // });

}]);
